import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Container, Typography } from "@mui/material";
import { toast } from "react-toastify";
import * as colendingActions from "../../actions/colendingActions";
import * as userActions from "../../actions/userActions";
import { encryptData } from "../../utils/cryptoUtils";

const ColendingMasterCreatePage = (props) => {
  const { actions } = props;
  const { id } = useParams();
  const navigate = useNavigate();
  const { register, handleSubmit, setValue } = useForm();

  const [charges, setCharges] = useState([]);

  useEffect(() => {
    if (id) {
      const decoded = atob(id);
      actions.colendingData(encryptData({ id: decoded }))
        .then(res => {
          if (res.data.success) {
            const d = res.data.data?.data?.[0];

            console.log(" record data = ", d);

            Object.keys(d).forEach(k => setValue(k, d[k]));
            setCharges(d.extra_charges || []);
          }
        })
    }
  }, []);

  const addCharge = () => {
    setCharges([...charges, { label: "", charge1: "", charge2: "" }]);
  };

  const onSubmit = (data) => {
    const pairs = [
      ["split1", "split2"],
      ["pf1", "pf2"],
      ["cli1", "cli2"],
      ["fc1", "fc2"],
      ["pre1", "pre2"],
      ["ins1", "ins2"],
      ["sub1", "sub2"]
    ];

    const invalidPair = pairs.some(([a, b]) => {
      const total = Number(data[a] || 0) + Number(data[b] || 0);

      if (total !== 100) {
        toast.error(`${a} + ${b} must equal 100`);
        return true; // stop iteration
      }

      return false;
    });

    if (invalidPair) return;

    data.extra_charges = charges;
    if (id) data.id = atob(id);

    actions.createColendingMaster(encryptData(data))
      .then(res => {
        if (res.data.success) { 
           toast.success(res.data.message, {
                      position: "top-right",
                    });
          
          setTimeout(() => {
             navigate("/dashboard/colending-master");
          }, 5000); 
        }else{
            toast.error(res.data.message, { 
                      position: "top-right",
                    });
        }
      })
  };

  const removeCharge = (index) => {
  const updated = charges.filter((_, i) => i !== index);
  setCharges(updated);
};

  return (
    <Container>
      <Typography variant="h4" sx={{ mb: 2 }}>
        {id ? "Edit" : "Create"} Co-Lending Master
      </Typography>

      <form onSubmit={handleSubmit(onSubmit)}>

        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="final_outcome">
                <span>Co-Lending Identifier</span>
                <input className="form-control mb-3"
                  placeholder="Identifier"
                  {...register("identifier", { required: true })} />
              </label>
            </div>
          </div>

        </div>
        <div className="row">

          <div className="col-md-6">
            <label htmlFor="final_outcome"> <span>Lender 1</span> </label>
            <hr />

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="final_outcome">
                  <span>Name</span>
                  <input className="form-control mb-2" placeholder="Lender1 Name" {...register("lender1_name")} />
                </label>
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="final_outcome">
                  <span>Split %</span>

                  <input className="form-control mb-2" placeholder="Split %" {...register("split1")} />
                </label>
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="final_outcome">
                  <span>Processing Fee</span>
                  <input className="form-control mb-2" placeholder="Processing Fee" {...register("pf1")} />
                </label>
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="final_outcome">
                  <span>Credit LI Amount</span>
                  <input className="form-control mb-2" placeholder="Credit LI" {...register("cli1")} />
                </label>
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="final_outcome">
                  <span>File Charges</span>
                  <input className="form-control mb-2" placeholder="File Charges" {...register("fc1")} />
                </label>
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="final_outcome">
                  <span>Pre-EMI</span>
                  <input className="form-control mb-2" placeholder="Pre EMI" {...register("pre1")} />
                </label>
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="final_outcome">
                  <span>Insurance (CFPL)</span>
                  <input className="form-control mb-2" placeholder="Insurance" {...register("ins1")} />
                </label>
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="final_outcome">
                  <span>Dealer Subvention</span>
                  <input className="form-control mb-2" placeholder="Dealer Subvention" {...register("sub1")} />

                </label>
              </div>
            </div>


          </div>

          <div className="col-md-6">
            <label htmlFor="final_outcome"> <span>Lender 1</span> </label>
            <hr />
           
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="final_outcome">
                  <span>Name</span>
            <input className="form-control mb-2" placeholder="Lender2 Name" {...register("lender2_name")} />
           </label>
              </div>
            </div>

             <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="final_outcome">
                  <span>Split %</span>
            <input className="form-control mb-2" placeholder="Split %" {...register("split2")} />
            
            </label>
              </div>
            </div>

             <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="final_outcome">
                  <span>Processing Fee</span>
            <input className="form-control mb-2" placeholder="Processing Fee" {...register("pf2")} />
            </label>
              </div>
            </div>

             <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="final_outcome">
                  <span>Credit LI Amount</span>
            <input className="form-control mb-2" placeholder="Credit LI" {...register("cli2")} />
            </label>
              </div>
            </div>

             <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="final_outcome">
                  <span>File Charges</span>
            <input className="form-control mb-2" placeholder="File Charges" {...register("fc2")} />
           </label>
              </div>
            </div>

             <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="final_outcome">
                  <span>Pre-EMI</span>
            <input className="form-control mb-2" placeholder="Pre EMI" {...register("pre2")} />
           </label>
              </div>
            </div>

             <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="final_outcome">
                  <span>Insurance (CFPL)</span>
            <input className="form-control mb-2" placeholder="Insurance" {...register("ins2")} />
           </label>
              </div>
            </div>

             <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="final_outcome">
                  <span>Dealer Subventio</span>
            <input className="form-control mb-2" placeholder="Dealer Subvention" {...register("sub2")} />
          </label>
              </div>
            </div>

             
          </div>
        </div>

        <hr />

        <button type="button" className="btn btn-secondary mb-3" onClick={addCharge}>
          + Charges
        </button>
      <hr />
        {charges.map((c, i) => (
          <div className="row mb-2 align-items-center" key={i}>

                <div className="col-md-3">
                  <input
                    className="form-control"
                    placeholder="Label"
                    value={c.label}
                    onChange={e => {
                      const arr = [...charges];
                      arr[i].label = e.target.value;
                      setCharges(arr);
                    }}
                  />
                </div>

                <div className="col-md-3">
                  <input
                    className="form-control"
                    placeholder="Charge1"
                    value={c.charge1}
                    onChange={e => {
                      const arr = [...charges];
                      arr[i].charge1 = e.target.value;
                      setCharges(arr);
                    }}
                  />
                </div>

                <div className="col-md-3">
                  <input
                    className="form-control"
                    placeholder="Charge2"
                    value={c.charge2}
                    onChange={e => {
                      const arr = [...charges];
                      arr[i].charge2 = e.target.value;
                      setCharges(arr);
                    }}
                  />
                </div>

                <div className="col-md-3 text-end">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => removeCharge(i)}
                  >
                    ✕
                  </button>
                </div>

              </div>
        ))}

        <button className="btn btn-primary">Submit</button>
        <br/>  <br/>
      </form>
    </Container>
  )
}

function mapDispatch(dispatch) {
  return {
    actions: bindActionCreators(
      Object.assign(colendingActions.default, userActions.default),
      dispatch
    )
  }
}

export default connect(null, mapDispatch)(ColendingMasterCreatePage);